import { FindParamsDefault } from './find-params-default';

export interface FindCharitiesParams extends FindParamsDefault {
  organization_id?: string;
  'couriers_available[]'?: string[];
  discount_enabled?: boolean;
}
